import { render, staticRenderFns } from "./PlayerHome.vue?vue&type=template&id=761933ae&"
import script from "./PlayerHome.vue?vue&type=script&lang=ts&"
export * from "./PlayerHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports